import { AdvancedMarker } from '@vis.gl/react-google-maps'
import { useCallback } from 'react'

import { Drawer } from '#/components/Drawer'
import { Icon } from '#/components/Icon'
import { DrawerFetch } from '#/components/Maps/components/DrawerFetch'
import Pin from '#/components/Maps/components/Pin'
import FarmContent, { FarmDrawerFooter } from '#/components/Maps/Markers/Farm/drawer'
import { Farm } from '#/components/Maps/Markers/types'
import { usePermissions } from '#/store/ducks/permissions'
import { endpoint } from '#/store/services/endpoints'

interface FarmMarkerProps {
  marker: Farm
  setMarkerRef: (marker: google.maps.marker.AdvancedMarkerElement, slug: string) => void
}

export function FarmMarker({ marker, setMarkerRef }: FarmMarkerProps) {
  const permissions = usePermissions()

  const ref = useCallback(
    (ref: google.maps.marker.AdvancedMarkerElement) => setMarkerRef(ref, marker.id),
    [setMarkerRef, marker.id],
  )

  return (
    <AdvancedMarker
      key={marker.id}
      position={marker}
      onClick={() => farmDrawerOpen(marker, permissions)}
      ref={ref}
    >
      <Pin icon={<Icon size="large" name="home" />} backgroundColor="#42a5f5" color="#fff" />
    </AdvancedMarker>
  )
}

export const farmDrawerOpen = (marker: FarmMarkerProps['marker'], permissions) => {
  return Drawer.open({
    content: (
      <DrawerFetch
        controller={
          permissions.system.list_ccom
            ? endpoint.dataview.c_com.farm_ccom_count({ farm: marker.slug })
            : null
        }
        marker={marker}
        render={data => <FarmContent data={data} farm={marker} />}
      />
    ),
    footer: <FarmDrawerFooter marker={marker} />,
  })
}
